/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateEditRequestDto,
  EditRequestDto,
  EditRequestListDto,
  EditRequestsControllerListParams,
  ReviewEditRequestDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Powers the coop-admin "Pending Reviews" inbox on web. Scope: admin sees all; coop_admin sees requests for farmers in cooperatives they admin; farmer sees only their own requests (any status). Each item carries the farmer's current values alongside the proposed_* values for diff display.
 * @summary TD-049 — list edit requests (paginated; default status=pending)
 */
export const editRequestsControllerList = (
    params?: EditRequestsControllerListParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<EditRequestListDto>(
      {url: `/farmer_profile_edit_requests`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getEditRequestsControllerListQueryKey = (params?: EditRequestsControllerListParams,) => {
    return [
    `/farmer_profile_edit_requests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getEditRequestsControllerListQueryOptions = <TData = Awaited<ReturnType<typeof editRequestsControllerList>>, TError = unknown>(params?: EditRequestsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editRequestsControllerList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEditRequestsControllerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof editRequestsControllerList>>> = ({ signal }) => editRequestsControllerList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof editRequestsControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type EditRequestsControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof editRequestsControllerList>>>
export type EditRequestsControllerListQueryError = unknown


export function useEditRequestsControllerList<TData = Awaited<ReturnType<typeof editRequestsControllerList>>, TError = unknown>(
 params: undefined |  EditRequestsControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof editRequestsControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof editRequestsControllerList>>,
          TError,
          Awaited<ReturnType<typeof editRequestsControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useEditRequestsControllerList<TData = Awaited<ReturnType<typeof editRequestsControllerList>>, TError = unknown>(
 params?: EditRequestsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editRequestsControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof editRequestsControllerList>>,
          TError,
          Awaited<ReturnType<typeof editRequestsControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useEditRequestsControllerList<TData = Awaited<ReturnType<typeof editRequestsControllerList>>, TError = unknown>(
 params?: EditRequestsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editRequestsControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary TD-049 — list edit requests (paginated; default status=pending)
 */

export function useEditRequestsControllerList<TData = Awaited<ReturnType<typeof editRequestsControllerList>>, TError = unknown>(
 params?: EditRequestsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editRequestsControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getEditRequestsControllerListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Mobile-side offline-first write — the SyncEngine outbox queues an op pointing here and /sync/push dispatches it via Fastify-inject. The caller proposes changes to their own profile. Coop admin review/approve is a separate workflow (Phase 1 follow-on).
 * @summary Submit a farmer-profile edit request (self)
 */
export const editRequestsControllerCreate = (
    createEditRequestDto: CreateEditRequestDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<EditRequestDto>(
      {url: `/farmer_profile_edit_requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEditRequestDto, signal
    },
      );
    }
  


export const getEditRequestsControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editRequestsControllerCreate>>, TError,{data: CreateEditRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof editRequestsControllerCreate>>, TError,{data: CreateEditRequestDto}, TContext> => {

const mutationKey = ['editRequestsControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editRequestsControllerCreate>>, {data: CreateEditRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  editRequestsControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EditRequestsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof editRequestsControllerCreate>>>
    export type EditRequestsControllerCreateMutationBody = CreateEditRequestDto
    export type EditRequestsControllerCreateMutationError = unknown

    /**
 * @summary Submit a farmer-profile edit request (self)
 */
export const useEditRequestsControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editRequestsControllerCreate>>, TError,{data: CreateEditRequestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editRequestsControllerCreate>>,
        TError,
        {data: CreateEditRequestDto},
        TContext
      > => {

      const mutationOptions = getEditRequestsControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * admin or coop_admin reviews. coop_admin must admin the target farmer's cooperative. On approve, every non-null proposed_* value is applied to the farmer's profile in the same transaction. On reject, status flips with no profile change. Already-reviewed requests (status != pending) return 400.
 * @summary TD-049 — review a pending edit-request (approve or reject)
 */
export const editRequestsControllerReview = (
    id: string,
    reviewEditRequestDto: ReviewEditRequestDto,
 ) => {
      
      
      return fseAxios<EditRequestDto>(
      {url: `/farmer_profile_edit_requests/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: reviewEditRequestDto
    },
      );
    }
  


export const getEditRequestsControllerReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editRequestsControllerReview>>, TError,{id: string;data: ReviewEditRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof editRequestsControllerReview>>, TError,{id: string;data: ReviewEditRequestDto}, TContext> => {

const mutationKey = ['editRequestsControllerReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editRequestsControllerReview>>, {id: string;data: ReviewEditRequestDto}> = (props) => {
          const {id,data} = props ?? {};

          return  editRequestsControllerReview(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EditRequestsControllerReviewMutationResult = NonNullable<Awaited<ReturnType<typeof editRequestsControllerReview>>>
    export type EditRequestsControllerReviewMutationBody = ReviewEditRequestDto
    export type EditRequestsControllerReviewMutationError = unknown

    /**
 * @summary TD-049 — review a pending edit-request (approve or reject)
 */
export const useEditRequestsControllerReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editRequestsControllerReview>>, TError,{id: string;data: ReviewEditRequestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editRequestsControllerReview>>,
        TError,
        {id: string;data: ReviewEditRequestDto},
        TContext
      > => {

      const mutationOptions = getEditRequestsControllerReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    